import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

function ProductPage() {
  const { id } = useParams();
  const navigate = useNavigate();   // ← ADD THIS
  const [product, setProduct] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(-1);

  useEffect(() => {
    fetch("/products.json")
      .then((res) => res.json())
      .then((data) => {
        const found = data.find((p) => p.id === Number(id));
        setProduct(found);
      })
      .catch((err) => console.error("Failed to load product", err));
  }, [id]);

  if (!product) {
    return (
      <p className="pt-24 text-center text-red-600">Product not found.</p>
    );
  }

  return (
    <main className="pt-24 max-w-6xl mx-auto px-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        {/* Product Images */}
        <div>
          <div className="flex items-center justify-center bg-gray-100 rounded-lg shadow-lg cursor-pointer h-96">
            <img
              src={product.images[0]}
              alt={product.name}
              className="max-h-full w-auto object-contain"
              onClick={() => setLightboxIndex(0)}
            />
          </div>

          {/* Thumbnails */}
          <div className="flex mt-4 space-x-3 overflow-x-auto">
            {product.images.map((img, i) => (
              <div
                key={i}
                className="flex items-center justify-center bg-gray-100 rounded-lg shadow cursor-pointer hover:scale-105 transition w-24 h-24"
                onClick={() => setLightboxIndex(i)}
              >
                <img
                  src={img}
                  alt={`${product.name} ${i + 1}`}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Product Details */}
        <div className="flex flex-col justify-center">
          <h2 className="text-3xl font-bold text-brand-red mb-4">
            {product.name}
          </h2>
          <p className="text-xl font-semibold text-gray-800 mb-2">
            {product.price}
          </p>
          <p className="text-gray-700 mb-4">{product.description}</p>

          {product.dimensions && (
            <p className="text-md text-gray-600 mb-4">
              📏 <span className="font-medium">Dimensions:</span>{" "}
              {product.dimensions}
            </p>
          )}

          {/* ← FIXED BACK BUTTON */}
          <button
            onClick={() => navigate(-1)}
            className="mt-4 text-brand-red font-semibold hover:underline cursor-pointer"
          >
            ← Back to Products
          </button>
        </div>
      </div>

      {/* Lightbox */}
      <Lightbox
        open={lightboxIndex >= 0}
        index={lightboxIndex}
        close={() => setLightboxIndex(-1)}
        slides={product.images.map((img) => ({ src: img }))}
      />
    </main>
  );
}

export default ProductPage;